import * as React from 'react';
import { Form, Input, Button, Select, Divider, message, Spin, Checkbox, Tooltip } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { RouteComponentProps, withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import ResetPasswordDTO from 'src/models/account/ResetPasswordDTO';
import UserApiController from 'src/api/UserApiController';

interface RouteParams {
    classroomId: string;
    userId: string;
    isAdmin: string;
}

interface ResetPasswordProps extends PageProps<RouteParams>, LocalizeContextProps { }

interface ResetPasswordState {
    isSubmitting: boolean;
    currentResetPassword: ResetPasswordDTO;
}

interface ResetPasswordFormProps {
    currentResetPassword: ResetPasswordDTO;
    translate: (id: any) => any;
    onChange: (changedFields: any[]) => void;
}

// Form
let ResetPasswordForm = Form.create({
    onFieldsChange(props: ResetPasswordFormProps, changedFields: any[]) {
        props.onChange(changedFields);
    }
})(class extends React.Component<ResetPasswordFormProps & FormComponentProps> {
    constructor(props: ResetPasswordFormProps & FormComponentProps) {
        super(props);
    }

    compareToFirstPassword = (rule, value, callback) => {
        if (value && value !== this.props.form.getFieldValue('newPassword')) {
            callback(this.props.translate('account.resetPassword.saveTooltip').toString());
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        if (this.props.form.getFieldValue('confirmPassword')) {
            this.props.form.validateFields(['confirmPassword'], { force: true }, (errors, values) => console.log('Revalidating'));
        }
        callback();
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 5 },
        };

        let passwordMinLength = 8;

        return (
            <Form>
                <Form.Item {...formItemLayout} label={this.props.translate('account.resetPassword.formItem1')}>
                    {this.props.form.getFieldDecorator('newPassword', {
                        initialValue: this.props.currentResetPassword.newPassword,
                        rules: [
                            { required: true, message: this.props.translate('admin.common.requiredRule') },
                            { min: passwordMinLength, message: this.props.translate("admin.common.minLengthRule").toString() + passwordMinLength },
                            { validator: this.validateToNextPassword }
                        ]
                    })(<Input autoComplete="off" type="password" />)}
                </Form.Item>

                <Form.Item {...formItemLayout} label={this.props.translate('account.resetPassword.formItem2')}>
                    {this.props.form.getFieldDecorator('confirmPassword', {
                        initialValue: this.props.currentResetPassword.confirmPassword,
                        rules: [
                            { required: true, message: this.props.translate('admin.common.requiredRule') },
                            { validator: this.compareToFirstPassword }
                        ]
                    })(<Input autoComplete="off" type="password" />)}
                </Form.Item>

            </Form>
        );
    }
});

class ResetPassword extends React.Component<ResetPasswordProps, ResetPasswordState> {
    private formRef: React.Component<FormComponentProps>;

    constructor(props: ResetPasswordProps) {
        super(props);
        bindAllOfThis(this, ResetPassword.prototype);

        let userId = parseInt(this.props.match.params.userId, 10);
        
        this.state = {
            isSubmitting: false,
            currentResetPassword: {
                userId: userId,
                newPassword: "",
                confirmPassword: ""
            } as ResetPasswordDTO
        };
    }

    private handleInputChange(changedFields: any[]): void {
        let newState = {};
        for (var key in changedFields) {
            if (changedFields.hasOwnProperty(key)) {
                let field: any = changedFields[key];
                newState[key] = field.value;
            }
        }
        this.setState({
            currentResetPassword: { ...this.state.currentResetPassword, ...newState }
        });
    }

    private handleRedirect(): void {
        let classroomId = parseInt(this.props.match.params.classroomId, 10);
        let isAdmin = this.props.match.params.isAdmin === 'true' ? true : false;

        let redirectUrl = classroomId ?
            Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLASSROOM, classroomId) :
            Routes.getRoute(Routes.ADMIN_USERS, isAdmin);

        this.props.history.push(redirectUrl);
    }

    private handleSubmit(e): void {
        e.preventDefault();

        this.formRef.props.form.validateFields((error: any, values: any) => {
            if (!error) {
                this.setState({ isSubmitting: true });
                UserApiController.adminPasswordReset(this.state.currentResetPassword).then(result => {
                    message.success(this.props.translate('account.resetPassword.messageReset'));
                    this.setState({ isSubmitting: false });
                    this.handleRedirect();
                }).catch(e => {
                    message.error(this.props.translate('account.resetPassword.messageResetError'));
                    this.setState({ isSubmitting: false });
                });
            }
        });
    }

    render() {
        let formProps: ResetPasswordFormProps = {
            currentResetPassword: this.state.currentResetPassword,
            translate: this.props.translate,
            onChange: this.handleInputChange
        };

        return (
            <div>
                <h2>
                    {this.props.translate('account.resetPassword.header')}
                </h2>

                <ResetPasswordForm wrappedComponentRef={ref => this.formRef = ref} {...formProps} />

                <div>
                    <Button type="primary" onClick={this.handleSubmit} loading={this.state.isSubmitting}>
                        {this.props.translate('account.resetPassword.button1')}
                    </Button>
                    <Divider type="vertical" />
                    <Button onClick={this.handleRedirect}>
                        {this.props.translate('account.resetPassword.button2')}
                    </Button>
                </div>
            </div >
        );
    }
}

export default withLocalize(ResetPassword as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/ResetPassword.tsx